<template>
  <step-container :number="stepNumber" :title="title">
    <card-option
      v-for="(service, index) in interviewServices"
      v-model="option"
      :key="index"
      :content="index + 1"
      :index="index.toString()"
      :stepNumber="stepNumber"
      :name="'duration'"
    >
      <interview-service-card
        :service="service"
        :index="index"
        :protagonistInterviewee="quotation.protagonistInterviewee"
      />
    </card-option>

    <template #footer>
      <p class="text-sm mt-2">
        <span class="font-medium">*El pago se realiza una vez grabada la Memooria</span>
        (hasta 3 cuotas)
      </p>
    </template>
  </step-container>
</template>

<script>
import stepMixin from "../../mixins/step";
import optionMixin from "../../mixins/option";

import InterviewServiceCard from "../options/InterviewServiceCard.vue";
import CardOption from "../options/CardOption.vue";
import StyledButton from "../layouts/StyledButton.vue";

import { createQuotation } from "../../../../../api/quotation";

export default {
  mixins: [stepMixin, optionMixin],
  inject: ["isAuthenticated"],
  components: {
    InterviewServiceCard,
    CardOption,
    StyledButton,
  },
  props: {
    interviewServices: {
      type: Array,
      required: true,
    },
    quotation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    title() {
      if (this.quotation.protagonistInterviewee) {
        return "¿Cuánto tiempo quieres que dure la conversación?";
      } else {
        return "¿A cuantas personas te gustaría entrevistar? (mínimo 15 minutos por entrevista)";
      }
    },
  },
};
</script>
